import { faPlus, faUserGroup } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { OrganizationUserList } from '~/components/organisms/OrganizationUserList';
import { OrganizationUsersTabs } from '~/components/organisms/OrganizationUsersTabs';
import { parseOrganizationUserRoles } from '~/helpers/parseOrganizationUserRoles';
import { useOrganizationUserQuery } from '~/lib/api/modules/Organizations/hooks/useOrganizationUserQuery';

export type IOrganizationUsersPageProps = {
  organizationId: string;
};

export const OrganizationUsersPage: React.FC<IOrganizationUsersPageProps> = (
  props,
) => {
  const { organizationId } = props;
  const { t } = useTranslation();
  const organizationUserQuery = useOrganizationUserQuery({
    organizationId,
  });
  const organizationUserRoles = organizationUserQuery.data?.roles
    ? parseOrganizationUserRoles(organizationUserQuery.data?.roles)
    : undefined;

  return (
    <>
      <Helmet>
        <title>{t('common.organizationUsers')}</title>
      </Helmet>
      <Heading
        icon={<FontAwesomeIcon icon={faUserGroup} />}
        title={t('common.organizationUsers')}
        subtitle={t('OrganizationUsersPage.subtitle')}
        actions={
          organizationUserRoles?.atLeastAdmin ? (
            <Button
              href={`/organizations/${organizationId}/invitations/create`}
              icon={<FontAwesomeIcon icon={faPlus} />}
            >
              {t('OrganizationUsersPage.invite')}
            </Button>
          ) : undefined
        }
      />

      {organizationUserRoles?.atLeastAdmin ? (
        <OrganizationUsersTabs
          organizationId={organizationId}
          defaultAnchor="collaborators"
        />
      ) : null}
      <OrganizationUserList
        organizationId={organizationId}
        roles={organizationUserRoles}
      />
    </>
  );
};
